<template>
  <div>
    This is the average power that the platform needs. It is
                    used to compute the available power during the simulation.
  </div>
</template>

<script>
export default {
  name: 'tooltipPlatformPower'
}
</script>
